import React from 'react';
import { Form, Button, Row, Col, Select } from 'antd';
import { SCMRangePicker, User } from '@HOC';
import styles from './form.scss';

const { Option } = Select;
const FormItem = Form.Item;
const formItemLayout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const RecordForm = React.memo(
  ({ loading, setSearchParams, searchParams, logDataType, ...props }) => {
    const {
      form: { resetFields, validateFields, getFieldDecorator },
    } = props;

    // 重置
    const reset = () => {
      resetFields();
    };

    // 查询
    const handleSearch = () => {
      validateFields((errors, values) => {
        if (!errors) {
          const { actionTime, ...others } = values;
          const params = {
            ...searchParams,
            ...others,
            pageNum: 1,
          };
          if (actionTime && actionTime.length !== 0) {
            params.createTimeStart = actionTime[0].format('YYYY-MM-DD HH:mm:ss');
            params.createTimeEnd = actionTime[1].format('YYYY-MM-DD HH:mm:ss');
          } else {
            delete params.createTimeStart;
            delete params.createTimeEnd;
          }
          setSearchParams({
            ...params,
          });
        }
      });
    };

    return (
      <Form className={styles.form}>
        <Row>
          <Col span={8}>
            <FormItem label="操作类型" {...formItemLayout}>
              {getFieldDecorator('operType')(
                <Select allowClear placeholder="请选择">
                  <Option value={1}>新增</Option>
                  <Option value={2}>变更</Option>
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="操作属性" {...formItemLayout}>
              {getFieldDecorator('operAttribute')(
                <Select allowClear placeholder="请选择">
                  {logDataType === 3
                    ? [
                        <Option key={8} value={8}>
                          现货库存变更
                        </Option>,
                        <Option key={9} value={9}>
                          配送范围变更
                        </Option>,
                        <Option key={10} value={10}>
                          物流公司变更
                        </Option>,
                      ]
                    : null}
                  {logDataType === 2
                    ? [
                        <Option key={6} value={6}>
                          模板名称变更
                        </Option>,
                        <Option key={7} value={7}>
                          发货地区变更
                        </Option>,
                      ]
                    : null}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="操作人" {...formItemLayout}>
              {getFieldDecorator('createById')(<User isSingleSelect />)}
            </FormItem>
          </Col>
          <Col span={10}>
            <FormItem
              label="操作时间"
              labelCol={{
                span: 6,
              }}
              wrapperCol={{
                span: 18,
              }}>
              {getFieldDecorator('actionTime')(
                <SCMRangePicker style={{ width: '100%' }} showTime />,
              )}
            </FormItem>
          </Col>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Button type="primary" loading={loading} onClick={handleSearch}>
              查询
            </Button>
            <Button style={{ marginLeft: 8 }} onClick={reset}>
              重置
            </Button>
          </Col>
        </Row>
      </Form>
    );
  },
);

export default Form.create()(RecordForm);
